import styled from 'styled-components';

export const StyledRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: center;
    height: auto;
    width: 100%;
    margin-bottom: 10em;
    margin-top: 5em;

    div.pathways-container {
        display: flex;
        flex-direction: column;
        // width: 60%;
        margin-right: 15em;
        align-items:center;
    }

    div.pathways-metrics {
        // width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 4em;      

        div.signup-tile {      
          display: flex;
           flex-direction: column;
           align-items: center;           
           justify-content: center;
           width: 400px; 
           height: 200px;
           background-color: #2a2a2a;
           border-radius: 5px;
           margin-top: 4em;
           padding: 1.5em;
           
            
            p {
                font: italic bold 18px 'Roboto';
                color: #fff;
                text-align: center;
            }
            .onboard-signup {
                height: 36px;
                width: 200px;
                font-size: 13px;
                padding: 0 2em;
                margin-top: 1em;
            }
        }
        
    }

    // modal
    div.edit-modal {
        h1 {
            font: bold normal 22px 'Roboto';
            text-align: center;
            width: 100%;
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/Onboard/Student/PlexPathways/Plexing.styles.ts